// extracted by mini-css-extract-plugin
module.exports = {"vnrb-homeTopSlider":"StorySlider_vnrb-homeTopSlider__gOq1a","dotsSlider":"StorySlider_dotsSlider__FPtg9","vsaSlider":"StorySlider_vsaSlider__CJzla"};